import { ComponentProps } from "react"
import { cva, type VariantProps } from "cva"
import { Loader2 } from "lucide-react"

import { cn } from "../lib"

const buttonVariants = cva({
  base: "flex w-full items-center justify-center gap-1 text-base/none font-bold tracking-[-0.5px] transition-opacity disabled:pointer-events-none disabled:opacity-20",
  variants: {
    appearance: {
      tertiary: "bg-tertiary-main text-white active:opacity-75",
      green: "bg-green-100 text-black-100 active:opacity-75",
    },
    size: {
      small: "h-[43px] rounded-full",
      medium: "h-[60px] rounded-2xl",
    },
  },
})

export type ButtonVariantProps = VariantProps<typeof buttonVariants>

const Button = ({
  className,
  isLoading,
  children,
  appearance,
  size,
  ...props
}: ComponentProps<"button"> &
  Required<Pick<VariantProps<typeof buttonVariants>, "appearance" | "size">> & {
    isLoading?: boolean
  }) => {
  return (
    <button
      className={cn(buttonVariants({ appearance, size }), className)}
      {...props}
    >
      {isLoading ? <Loader2 className="size-4 animate-spin" /> : children}
    </button>
  )
}

export default Button
